import { ECategoryType } from '@/services/doctor/DiagnosisCategoryService';
import { ROUTES } from '@/types/common';
import { addQueryString } from '@/utils/url';

export enum FEATURE_FLAG {}

export const SIX_HOURS_IN_MILLISECONDS = 1000 * 60 * 60 * 6;

export const APP_PUBLIC_DOWNLOAD_URL = 'https://abr.ge/@doctornow';
export const APP_TRACKING_CHANNEL = 'web_organic';
export const APP_GENERAL_TRACKING_PARAMS =
  'og_tag_id=138187085&routing_short_id=d816rm&tracking_template_id=2b94e9766fea0e112f2b11b7410088c4&ad_type=click';

export const APP_STORE_PAGE_LINK_TRACKING_PARAMS =
  'og_tag_id=138187710&routing_short_id=pzm4azo&tracking_template_id=a82e9a369aeb09d88afb5812cf2376b6&ad_type=click';

export const TELEMEDICINE_SUBMENUS = [
  {
    text: '소아청소년과',
    url:
      ROUTES.TELEMEDICINE.DOCTORS.path +
      addQueryString({
        type: ECategoryType.Department,
        id: 2,
      }),
  },
  {
    text: '감기/독감',
    url:
      ROUTES.TELEMEDICINE.DOCTORS.path +
      addQueryString({
        type: ECategoryType.Treatment,
        id: 1,
      }),
  },
  {
    text: '인공눈물',
    url:
      ROUTES.TELEMEDICINE.DOCTORS.path +
      addQueryString({
        type: ECategoryType.Treatment,
        id: 558,
      }),
  },
  {
    text: '탈모',
    url:
      ROUTES.TELEMEDICINE.DOCTORS.path +
      addQueryString({
        type: ECategoryType.Treatment,
        id: 9,
      }),
  },
  {
    text: '여드름',
    url:
      ROUTES.TELEMEDICINE.DOCTORS.path +
      addQueryString({
        type: ECategoryType.Treatment,
        id: 11,
      }),
  },
  {
    text: '전체 보기',
    url: ROUTES.TELEMEDICINE.CATEGORIES.path,
  },
];

export const HOSPITAL_SUBMENUS = [
  {
    text: '이비인후과',
    url:
      ROUTES.HOSPITAL.NEIGHBORHOOD.path +
      addQueryString({
        keyword: '이비인후과',
        regionCode: 11,
        type: 'all',
      }),
  },
  {
    text: '피부과',
    url:
      ROUTES.HOSPITAL.NEIGHBORHOOD.path +
      addQueryString({
        keyword: '피부과',
        regionCode: 11,
        type: 'all',
      }),
  },
  {
    text: '내과',
    url:
      ROUTES.HOSPITAL.NEIGHBORHOOD.path +
      addQueryString({
        keyword: '내과',
        regionCode: 11,
        type: 'all',
      }),
  },
  {
    text: '산부인과',
    url:
      ROUTES.HOSPITAL.NEIGHBORHOOD.path +
      addQueryString({
        keyword: '산부인과',
        regionCode: 11,
        type: 'all',
      }),
  },
  {
    text: '가정의학과',
    url:
      ROUTES.HOSPITAL.NEIGHBORHOOD.path +
      addQueryString({
        keyword: '이비인후과',
        regionCode: 11,
        type: 'all',
      }),
  },
  {
    text: '전체 보기',
    url: ROUTES.HOSPITAL.HOME.path,
  },
];

export const NON_BENEFIT_SUBMENUS = [
  {
    text: '비급여 진료비',
    url: ROUTES.NON_BENEFIT.HOME.path,
  },
  {
    text: '최저가 약국',
    url: ROUTES.NON_BENEFIT.MAP.path,
  },
];

export const MAGAZINE_SUBMENUS = [
  {
    text: '건강 매거진',
    url: ROUTES.MAGAZINE.LIST.path + '/INTERNAL',
  },
  {
    text: '1분 FAQ',
    url: ROUTES.FAQ.LIST.path,
  },
  {
    text: '의약품 사전',
    url: ROUTES.MEDICINE_DICTIONARY.HOME.path,
  },
  {
    text: '질환백과',
    url: ROUTES.DISEASE_ENCYCLOPEDIA.HOME.path,
  },
];

export const QNA_SUBMENUS = [
  {
    text: '실시간 질문',
    url: ROUTES.QNA.REALTIME.path,
  },
  {
    text: '질문하기',
    url: ROUTES.QNA.WRITE.path,
  },
];
